<template>
  <div>
    <dashboard-header :text="$t('ui.detailDepartment')" :on-back="onGoBack"/>

    <div class="d-flex align-content-center justify-content-center">
      <v-card
          elevation="0"
          :loading="loading"
          class="card-border-10 mx-16 w-75">
        <div class="pa-5">
          <data-detail
              data-colon
              :items="items"
              :headers="tableHeaders"
          />
        </div>

      </v-card>
    </div>

  </div>
</template>

<script>
import {API2} from "../../api";
import DataDetail from "../base/DataDetail.vue";
import i18n from "../../lang/i18n";
import mixin from "../../mixin";
import DashboardHeader from "../component/DashboardHeader";

export default {
  components: {DataDetail, DashboardHeader},
  mixins: [mixin],
  name: "DetailDepartment",
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      detail: null,
    };
  },
  computed: {
    header() {
      return this.item ? this.item.name : ''
    },
    tableHeaders() {
      return [
        {key: 'title', label: this.$t('base.title'), thStyle: {width: '50%'}},
        {key: 'data', label: this.$t('base.content')}
      ]
    },
    items() {
      return [
        {
          title: i18n.t("ui.nameDepartment"),
          data: this.detail?.name
        },
        {
          title: i18n.t("ui.accountName"),
          data: this.detail?.dpInchargeEmployeeName
        },
        {
          title: i18n.t("ui.email"),
          data: this.detail?.dpEmail
        },
        {
          title: i18n.t("ui.phoneNumber"),
          data: this.detail?.dpPhoneNumber
        },
        {
          title: i18n.t("ui.inCharge"),
          data: this.detail && this.detail.inCharge === 1 ? i18n.t('base.yes') : i18n.t('base.no')
        },
        {
          title: i18n.t("base.createdAt"),
          data: this.detail ? this.formatDate(this.detail.createdAt) : ''
        },
        {
          title: i18n.t("base.updatedAt"),
          data: this.detail ? this.formatDate(this.detail.updatedAt) : ''
        },
      ]
    },
  },
  mounted() {
    this.onTab(this.item)
  },
  methods: {
    onTab(item) {
      if (item) this.getData(item)
    },
    async getData(item) {
      this.detail = null
      let res = await this.get(API2.DEPARTMENT, {path: item.data.departmentId})
      if (res) {
        this.detail = res
        // console.log('res', res)
      } else {
        // No data found, go back to list
        this.onGoBack();
      }
    },
    onGoBack() {
      this.openTab(0)
    }
  }
};
</script>

<style scoped>
</style>
